import { c as _c } from "react/compiler-runtime";
import { isPWAStandalone } from '@/utils/standalone-check';
import { useEffect } from 'react';

/**
 * Hook to manage app mode detection and notify the service worker.
 * Specifically handles PWA standalone mode detection.
 */
export const useAppMode = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = [];
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  useEffect(_temp3, t0);
};
function _temp() {
  navigator.serviceWorker.controller?.postMessage({
    type: "SET_APP_MODE"
  });
}
function _temp2(registration) {
  registration.active?.postMessage({
    type: "SET_APP_MODE"
  });
}
function _temp3() {
  const isStandalone = isPWAStandalone();
  if (typeof globalThis !== "undefined" && isStandalone) {
    globalThis.document.cookie = "x-app-mode-initial=; Max-Age=0; path=/;";
    if ("serviceWorker" in navigator) {
      const sendAppModeMessage = _temp;
      sendAppModeMessage();
      navigator.serviceWorker.ready.then(_temp2);
    }
  }
}